import React, { useState } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  Text,
  Checkbox,
  Button,
  VStack,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogCloseButton,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import AsyncSelect from "react-select/async/dist/react-select-async.esm";

const AccountForm = ({
  accountData,
  showPassword,
  errors,
  onInputChange,
  onCheckboxChange,
  onSubmit,
  onPasswordToggle,
  productSelect,
  loadProductOptions,
  onProductChange
}) => {
  const [isDeactivating, setIsDeactivating] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      setIsDeactivating(true);
      onOpen(); // Open the confirmation dialog
    } else {
      onCheckboxChange({
        name,
        value: "0", // Deactivate the checkbox
      });
    }
  };

  const confirmDeactivation = () => {
    onCheckboxChange({
      name: "is_deactive",
      value: "1", // Activate the checkbox
    });
    setIsDeactivating(false);
    onClose(); // Close the dialog
  };

  return (
    <VStack spacing={4} align="stretch">
      <FormControl isInvalid={!!errors.email}>
        <FormLabel>ایمیل</FormLabel>
        <Input
          type="email"
          name="email"
          value={accountData.email}
          onChange={onInputChange}
          placeholder="ایمیل را وارد کنید"
          textAlign="left"
          padding="1rem"
          border="1px solid"
          borderColor="gray.300"
          boxShadow="sm"
          _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
        />
        {errors.email && <Text color="red.500" fontSize="sm" mt={1}>{errors.email[0]}</Text>}
      </FormControl>
      <FormControl isInvalid={!!errors.password}>
        <FormLabel>رمز عبور</FormLabel>
        <InputGroup>
          <Input
            type={showPassword ? "text" : "password"}
            name="password"
            value={accountData.password}
            onChange={onInputChange}
            placeholder="رمز عبور را وارد کنید"
            textAlign="left"
            padding="1rem"
            border="1px solid"
            borderColor="gray.300"
            boxShadow="sm"
            _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
          />
          <InputRightElement width="3rem">
            <IconButton
              h="1.75rem"
              size="sm"
              onClick={onPasswordToggle}
              icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
              aria-label={showPassword ? "Hide password" : "Show password"}
            />
          </InputRightElement>
        </InputGroup>
        {errors.password && <Text color="red.500" fontSize="sm" mt={1}>{errors.password[0]}</Text>}
      </FormControl>
      <FormControl>
        <FormLabel>محصول</FormLabel>
        <AsyncSelect
          cacheOptions
          defaultOptions
          value={productSelect}
          loadOptions={loadProductOptions}
          onChange={onProductChange}
          placeholder="جستجو و انتخاب محصول..."
          isClearable
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          styles={{
            control: (base) => ({
              ...base,
              minHeight: 40,
              borderColor: "#CBD5E0",
              boxShadow: "none",
              ':hover': { borderColor: '#A0AEC0' },
            }),
            valueContainer: (base) => ({ ...base, padding: '0 12px' }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </FormControl>
      <FormControl isInvalid={!!errors.initial_price}>
        <FormLabel>قیمت اولیه</FormLabel>
        <Input
          type="number"
          name="initial_price"
          value={accountData.initial_price}
          onChange={onInputChange}
          placeholder="قیمت اولیه را وارد کنید"
          textAlign="left"
          padding="1rem"
          border="1px solid"
          borderColor="gray.300"
          boxShadow="sm"
          _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
        />
        {errors.initial_price && <Text color="red.500" fontSize="sm" mt={1}>{errors.initial_price[0]}</Text>}
      </FormControl>
      <FormControl>
        <FormLabel>دی اکتیوی؟</FormLabel>
        {accountData.is_deactive === "1" ? (
          <Text color="green.600" fontWeight="bold">
            دی اکتیو شده
          </Text>
        ) : (
          <Checkbox
            name="is_deactive"
            isChecked={accountData.is_deactive === "1"}
            colorScheme="blue"
            onChange={handleCheckboxChange}
          >
            دی اکتیو
          </Checkbox>
        )}
      </FormControl>
      <Button colorScheme="blue" onClick={onSubmit} borderRadius="md">
        بروزرسانی
      </Button>

      {/* Confirmation Dialog */}
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              تایید دی اکتیو سازی
            </AlertDialogHeader>
            <AlertDialogBody>
              آیا مطمئن هستید که می‌خواهید این حساب را دی اکتیو کنید؟
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                لغو
              </Button>
              <Button
                colorScheme="red"
                onClick={confirmDeactivation}
                ml={3}
              >
                تایید
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </VStack>
  );
};

export default AccountForm;
